import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { KeyBenefitItem } from './CommonTypes';

export type ShowBenefitsModalProps = {
  showModal: boolean;
  title: string;
  onCloseModal: () => void;
  showMoreItems?: KeyBenefitItem[];
};

const ShowBenefitsModal = ({
  showModal,
  onCloseModal,
  title,
  showMoreItems
}: ShowBenefitsModalProps): JSX.Element => {
  const renderShowMoreItems = () => {
    return showMoreItems?.map((item: KeyBenefitItem, i) => (
      <li key={`more-items-${i}`}>{item.text}</li>
    ));
  };

  return (
    <Modal isOpen={showModal}>
      <ModalHeader
        toggle={onCloseModal}
        className='modal-header-title cms-modal-header-title'>
        <span>{title}</span>
      </ModalHeader>
      <ModalBody className='show-more-container'>
        <ul className='cms'>{renderShowMoreItems()}</ul>
      </ModalBody>
    </Modal>
  );
};

export default ShowBenefitsModal;
